import { EffectAxis } from '@wix/effects-kit';
import {
  AnimationProperties,
  distanceWithUnit,
  MouseAnimationInstance,
  MouseParams,
} from '../../../types';
import { animate as trackAnimate } from './trackMouse';

export interface Params extends MouseParams {
  inverted?: boolean;
  distance?: distanceWithUnit;
  axis?: EffectAxis;
}

export const name = 'BounceMouse';
export const properties: AnimationProperties = {
  schema: {},
};

export function animate(
  _kit: any,
  elements: HTMLElement[],
  _duration: any,
  _delay: any,
  {
    inverted = false,
    distance = { value: 80, type: 'px' },
    axis = 'both',
    transitionDuration,
    transitionEasing = 'elastic',
  }: Params = {},
): MouseAnimationInstance {
  return trackAnimate(_kit, elements, _duration, _delay, {
    distance,
    inverted,
    axis,
    transitionDuration,
    transitionEasing,
  });
}
